// @flow

export default {
  wrapper: {
    display: 'inline-flex',
  },
};
